<div class="flex flex-row gap-3 align-items-end" [formGroup]="settingsForm">
  <div>
    <label class="block font-bold mb-2" for="control">Control</label>
    <input
      inputId="control"
      type="text"
      pInputText
      class="w-full p-inputtext"
      [disabled]="true"
      [value]="control"
    />
  </div>
  <p-button (onClick)="addControl()" class="ml-2">Select Control</p-button>
</div>
